import { render, staticRenderFns } from "./LabelAIcon.vue?vue&type=template&id=4370f543&"
import script from "./LabelAIcon.vue?vue&type=script&lang=js&"
export * from "./LabelAIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports